export const summaryRows: string[] = [
  'Volume 1 — Fondamenti di Geologia e Sistemi della Terra',
  'Volume 2 — Minerali, Cristalli e Ciclo delle Rocce',
  'Volume 3 — Tettonica delle Placche, Terremoti e Vulcani',
  'Volume 4 — Sedimentologia, Stratigrafia, Tempo Geologico e Paleontologia',
  'Volume 5 — Geologia Strutturale, Cartografia Geologica e Geomorfologia',
  'Volume 6 — Geologia Applicata, Ambientale ed Economica',
  'Bonus 1 — 150 Attività di Geologia per la Classe',
  'Bonus 2 — Raccolta di Verifiche di Geologia',
  'Bonus 3 — 50 Progetti di Geologia e Sfide STEM',
  'Bonus 4 — Guida del Docente a Concetti e Terminologia della Geologia',
  'Bonus 5 — 100 Casi di Studio di Geologia dal Mondo',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
